var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{staticClass:"text-center text-lg"},[(!_vm.content)?_c('default-null-html'):_c('div',{staticClass:"ping",class:_vm.quality,attrs:{"title":_vm.pingString}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }